/**
 * Candidate Intelligence Graph — itemized source of truth for ATS paste packs,
 * narrative projections, and AI Context markdown.
 *
 * Narrative lenses are user-defined (slug + label). Never hardcode role families
 * such as "CTO" or "commercial" — candidates come from any walk of life.
 */
export const EMPLOYMENT_TYPES = [
    "employee",
    "contractor",
    "founder",
    "advisory",
    "other",
];
export const CLAIM_CONFIDENCE = [
    "verified",
    "approximate",
    "do-not-use",
];
export const WORK_AUTH_STATUSES = [
    "citizen",
    "pr",
    "work_visa",
    "visit",
    "other",
];
export const SKILL_CATEGORIES = [
    "technical",
    "domain",
    "leadership",
    "tool",
    "other",
];
/** Slugify a user-provided lens label into a stable id. */
export function slugifyLensId(label) {
    const slug = label
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 64);
    return slug || `lens-${Date.now().toString(36)}`;
}
//# sourceMappingURL=candidate-graph.js.map